// Mirrors the colour-by-job hashing used on the Timer calendar
// (timer-tracker.component.ts: hslToHex / colorForHue / hueForAction) so a
// job looks the same colour on both calendars. Duplicated rather than
// imported so the Planner feature has zero dependency on the Timer
// module's internals — Timer's file is never touched by this feature.

export interface PlannerColorSet {
    bg: string;
    titleColor: string;
    hoverBg: string;
}

function hslToHex(h: number, s: number, l: number): string {
    s /= 100;
    l /= 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n: number) => {
        const k = (n + h / 30) % 12;
        const c = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
        return Math.round(255 * c).toString(16).padStart(2, '0');
    };
    return `#${f(0)}${f(8)}${f(4)}`;
}

function colorForHue(h: number): PlannerColorSet {
    return {
        bg: hslToHex(h, 60, 88),
        titleColor: hslToHex(h, 87, 33),
        hoverBg: hslToHex(h, 60, 86),
    };
}

function hueForKey(key: string): number {
    let h = 5381;
    for (let i = 0; i < key.length; i++) {
        h = ((h << 5) + h + key.charCodeAt(i)) >>> 0;
    }
    return h % 360;
}

export const PLANNER_NO_JOB_COLOR: PlannerColorSet = {
    bg: '#dbdbdb',
    titleColor: '#666666',
    hoverBg: '#d0d0d0',
};

// Hashes on jobNumber, same key the Timer calendar hashes on, so the same
// job/client renders the same colour on both calendars.
export function plannerColorForJobNumber(jobNumber?: number | null): PlannerColorSet {
    if (!jobNumber) return PLANNER_NO_JOB_COLOR;
    return colorForHue(hueForKey(String(jobNumber)));
}
